import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, ClipboardList } from 'lucide-react';
interface FinalCTAProps {
  language: 'en' | 'es';
}
export function FinalCTA({
  language
}: FinalCTAProps) {
  const t = {
    en: {
      heading: 'READY TO GET STARTED?',
      line1: 'Clean equipment. On-time delivery.',
      line2: 'Real people who answer the phone.',
      button: 'GET YOUR FREE QUOTE',
      reach: 'Or Reach Us Directly'
    },
    es: {
      heading: '¿LISTO PARA COMENZAR?',
      line1: 'Equipo limpio. Entrega a tiempo.',
      line2: 'Personas reales que contestan el teléfono.',
      button: 'OBTÉN TU COTIZACIÓN GRATIS',
      reach: 'O Contáctanos Directamente'
    }
  };
  const text = t[language];
  return <section id="contact" className="py-12 md:py-20 bg-gold text-black border-t-4 border-yellow-600 w-full overflow-hidden" data-id="element-54">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-56">
          <h2 className="font-oswald text-3xl sm:text-5xl md:text-6xl font-bold uppercase mb-4 md:mb-6 text-obsidian" data-id="element-57">
            {text.heading}
          </h2>
          <div className="font-inter text-lg sm:text-xl md:text-2xl font-semibold mb-6 md:mb-10 text-obsidian/90" data-id="element-58">
            <p data-id="element-59">{text.line1}</p>
            <p data-id="element-60">{text.line2}</p>
          </div>
          <a href="#quote" className="inline-flex items-center justify-center gap-2 bg-obsidian text-warmWhite px-10 py-5 rounded font-montserrat font-extrabold text-[16px] tracking-wide hover:bg-carbon hover:scale-105 transition-all duration-300 shadow-xl mb-8" data-id="element-61">
            <ClipboardList size={20} color="#F5F0E8" data-id="element-62" /> {text.button}
          </a>
          <p className="font-montserrat text-obsidian/70 text-sm font-bold tracking-widest uppercase mb-5" data-id="element-63">
            {text.reach}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto" data-id="element-64">
            <div className="bg-obsidian rounded-lg p-5 shadow-xl" data-id="element-65">
              <p className="font-oswald text-gold text-xl font-bold mb-3" data-id="element-66">
                432-528-7892
              </p>
              <div className="flex gap-3 justify-center" data-id="element-67">
                <a href="tel:+14325287892" className="flex-1 bg-gold text-obsidian py-2.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-yellow-500 transition-all duration-300 flex items-center justify-center gap-1.5" data-id="element-68">
                  <Phone size={15} data-id="element-69" /> Call
                </a>
                <a href="sms:+14325287892" className="flex-1 border-2 border-gold text-gold py-2.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-gold hover:text-obsidian transition-all duration-300 flex items-center justify-center gap-1.5" data-id="element-70">
                  <MessageSquare size={15} data-id="element-71" /> Text
                </a>
              </div>
            </div>
            <div className="bg-obsidian rounded-lg p-5 shadow-xl" data-id="element-72">
              <p className="font-oswald text-gold text-xl font-bold mb-3" data-id="element-73">
                432-803-4737
              </p>
              <div className="flex gap-3 justify-center" data-id="element-74">
                <a href="tel:+14328034737" className="flex-1 bg-gold text-obsidian py-2.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-yellow-500 transition-all duration-300 flex items-center justify-center gap-1.5" data-id="element-75">
                  <Phone size={15} data-id="element-76" /> Call
                </a>
                <a href="sms:+14328034737" className="flex-1 border-2 border-gold text-gold py-2.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-gold hover:text-obsidian transition-all duration-300 flex items-center justify-center gap-1.5" data-id="element-77">
                  <MessageSquare size={15} data-id="element-78" /> Text
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}